import React, { Component } from "react";
import { View, Text } from "react-native";
import { connect } from "react-redux";
import { getMatchRequest } from "@microdoing/shared/services/randomCoffee/actions";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { Loading, Button } from "../../components/common";
import Header from "./Header.js";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import Colors from "@microdoing/shared/constants/Colors";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import UserCard from "./UserCard";
import CoffeeLottie from "./CoffeeLottie";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import theme from "app/Theme/Theme";

class ChatScreen extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { userId, clientId, matchId } = this.props;
    this.props.getMatchRequest({ userId, clientId, lastMatchId: matchId });
  }

  componentWillReceiveProps = nextProps => {};

  componentWillUnmount() {}

  navigateExternalProfile = id => () => {
    this.props.requestExternalUser({ userId: id });
  };

  onPressNextMatch = () => {
    const { userId, clientId, matchId } = this.props;
    this.props.getMatchRequest({ userId, clientId, lastMatchId: matchId + 1 });
  };

  render() {
    const { match } = this.props;
    return (
      <View style={styles.main}>
        <Header
          testID={"coffee-back-button"}
          title={i18n.t("random-coffee")}
          navigation={this.props.navigation}
        />
        {this.props.requesting ? (
          <View
            style={{ justifyContent: "center", alignItems: "center", flex: 1 }}
          >
            <Loading size={wp("10%")} />
          </View>
        ) : (
          <View style={styles.meeting}>
            {/* <Text style={styles.title}>{i18n.t('my-meeting')}</Text> */}
            <View style={styles.userCards}>
              {match.map((el, i) => {
                return (
                  <UserCard
                    key={i}
                    {...el}
                    animation={
                      match.length > 1 && !i ? "fadeInLeft" : "fadeInRight"
                    }
                    onPressResult={this.navigateExternalProfile}
                  />
                );
              })}
            </View>

            <View style={styles.coffeeLottie}>
              <CoffeeLottie loop />
            </View>
            {this.props.error !== "" ? (
              <Text style={[styles.title, styles.error]}>
                {i18n.t(`error-${this.props.error}`)}
              </Text>
            ) : match.length < 1 && this.props.activated ? (
              <Text style={styles.title}>{i18n.t("wait-for-next-round")}</Text>
            ) : (
              <Text style={styles.title}>{i18n.t("coffee-click-avatar")}</Text>
            )}
            {!this.props.activated && this.props.error === "" && (
              <Button
                onPress={this.onPressNextMatch}
                text={i18n.t("coffee-done")}
                buttonPropStyle={{
                  backgroundColor: Colors.coffee,
                  marginTop: 20,
                  alignSelf: "center",
                }}
                // textPropStyle={{ fontWeight: 'bold' }}
              />
            )}
          </View>
        )}
      </View>
    );
  }
}

const styles = {
  main: {
    flex: 1,
    backgroundColor: theme.colors["neutral.white"],
  },
  userCards: {
    marginTop: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  title: {
    marginTop: -25,
    textAlign: "center",
    lineHeight: 20,
    marginLeft: 10,
    marginRight: 10,
    color: theme.colors["neutral.900"],
    fontSize: wp("4%"),
  },
  coffeeLottie: {
    zIndex: -10,
    marginTop: -25,
    width: wp("100%"),
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: "red",
  },
};

const mapStateToProps = state => {
  const { requesting, match, matchId, activated, error } = state.randomCoffee;
  return {
    language: state.profileSettings.language,
    isConnected: getIsConnected(state),
    requesting,
    match,
    matchId,
    activated,
    error,
    clientId: state.user.client,
    userId: getUserId(state),
  };
};

export default connect(mapStateToProps, {
  getMatchRequest,
  requestExternalUser,
})(ChatScreen);
